"use strict";
exports.__esModule = true;
exports.NotificationsProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var hooks_1 = require("../../hooks");
var context_1 = require("./context");
var model_1 = require("./model");
var reducer_1 = require("./reducer");
function NotificationsProvider(_a) {
    var children = _a.children;
    var _b = hooks_1.useLocalStorage('notifications'), storage = _b[0], setStorage = _b[1];
    var _c = react_1.useReducer(reducer_1.notificationReducer, storage !== null && storage !== void 0 ? storage : model_1.DEFAULT_NOTIFICATIONS), notifications = _c[0], dispatch = _c[1];
    react_1.useEffect(function () {
        setStorage(notifications);
    }, [notifications]);
    var addNotification = react_1.useCallback(function (_a) {
        var notification = _a.notification, chainId = _a.chainId;
        dispatch({
            type: 'ADD_NOTIFICATION',
            chainId: chainId,
            notification: notification
        });
    }, [dispatch]);
    return jsx_runtime_1.jsx(context_1.NotificationsContext.Provider, { value: { addNotification: addNotification, notifications: notifications }, children: children }, void 0);
}
exports.NotificationsProvider = NotificationsProvider;
//# sourceMappingURL=provider.js.map